(ns practitest.frontend.tests.batch-set-version-label
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [day8.re-frame.http-fx]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.tests.version-label-common :as label-common]
   [practitest.frontend.tests.events :as tests-events]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.common-entities.metadata :as metadata]
   [re-frame.core :as re-frame]))

(def state-key :batch-set-version-label)

(re-frame/reg-event-fx
  ::show-label-modal
  (label-common/show-modal-event state-key [::load-available-labels]))

(re-frame/reg-event-db
  ::hide-label-modal
  (fn [db _]
    (-> ((label-common/hide-modal-event state-key) db nil)
        (assoc-in [:form-states2 state-key :test-ids] nil))))

(re-frame/reg-event-db
  ::set-bdd-tests
  (fn [db [_ bdd-tests]]
    (assoc-in db [:form-states2 state-key :bdd-tests] bdd-tests)))

(re-frame/reg-event-db
  ::hide-bdd-message-modal
  (fn [db _]
    (assoc-in db [:form-states2 state-key :bdd-tests] nil)))

(re-frame/reg-event-db
  ::set-selected-labels
  (fn [db [_ labels]]
    (assoc-in db [:form-states2 state-key :selected-labels] (set labels))))

(re-frame/reg-event-fx
  ::load-available-labels
  (fn [{:keys [db]} [_ test-ids filters]]
    {:db (-> db
             (update :progress conj ::load-available-labels)
             (assoc-in [:form-states2 state-key :test-ids] test-ids))
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "version_labels#available_labels"
                                        {:p_id (subs/get-current-project-id db)}
                                        {:test_ids test-ids
                                         :filter filters})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::labels-loaded]
      :on-failure      [::labels-load-error]}}))

(re-frame/reg-event-fx
  ::labels-loaded
  (fn [{:keys [db]} [_ response]]
    (let [available-labels (:available_labels response)]
      {:db (-> db
               (assoc-in [:form-states2 state-key :available-labels] available-labels)
               (assoc-in [:form-states2 state-key :selected-labels] #{})
               (update :progress disj ::load-available-labels))})))

(re-frame/reg-event-fx ::labels-load-error (label-common/labels-load-error-event ::load-available-labels))
(re-frame/reg-event-fx ::create-label (label-common/create-label-event [::label-created]))
(re-frame/reg-event-db ::label-created (label-common/label-created-event state-key "Label Created"))

(re-frame/reg-event-fx
  ::apply-labels
  (fn [{:keys [db]} [_ test-ids selected-labels]]
    (let [label-ids (map :id selected-labels)]
      {:db (update db :progress conj ::batch-apply-labels)
       :http-xhrio
       {:method          :post
        :uri             (broutes/get-url "version_labels#batch_version_label_apply" {:p_id (subs/get-current-project-id db)})
        :params          {:test_ids test-ids
                          :label_ids label-ids}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::labels-applied]
        :on-failure      [::labels-apply-error]}})))

(re-frame/reg-event-fx
  ::labels-applied
  (fn [{:keys [db]} [_ response]]
    (mixpanel/track "Grid Actions" {"Action" "Batch Set Version Label Applied"})
    (let [table-id (get-in metadata/entities-metadata [:test :table-id])
          project-id (subs/get-current-project-id db)
          state-key (str project-id "-" table-id)
          per-page (or (grid-storage/load-per-page state-key) 10)
          current-page (or (grid-storage/load-current-page state-key) 1)
          grid-query {:per_page per-page :page current-page}
          success-message (or (:message response)
                             (get-translation "test.versioning.labels-applied-success" "Labels applied successfully"))
          bdd-tests (:bdd_tests response)
          dispatches (cond-> [[::hide-label-modal]
                              [::notifications/success2 success-message {:auto-close true}]
                              [:practitest.frontend.components.grid.events/clear-selection [:test tests-events/tests-index-state-key]]
                              [:practitest.frontend.common-entities.events/fetch-entity-list :test tests-events/tests-index-state-key grid-query]]
                       (seq bdd-tests)
                       (conj [::set-bdd-tests bdd-tests]))]
      {:db (update db :progress disj ::batch-apply-labels)
       :dispatch-n dispatches})))

(re-frame/reg-event-fx ::labels-apply-error (label-common/labels-apply-error-event ::batch-apply-labels))
(re-frame/reg-sub ::show-modal? (label-common/show-modal-sub state-key))
(re-frame/reg-sub ::available-labels (label-common/available-labels-sub state-key))
(re-frame/reg-sub ::selected-labels (label-common/selected-labels-sub state-key))

(re-frame/reg-sub
  ::test-ids
  (fn [db]
    (get-in db [:form-states2 state-key :test-ids])))

(re-frame/reg-sub
  ::bdd-tests
  (fn [db]
    (get-in db [:form-states2 state-key :bdd-tests])))

(defn bdd-message-modal []
  (fn []
    (let [bdd-tests @(re-frame/subscribe [::bdd-tests])]
      [modal/bootstrap-modal
       {:is-open? (seq bdd-tests)
        :on-request-close #(re-frame/dispatch [::hide-bdd-message-modal])
        :close-button? true
        :centered? true}

       [:div (get-translation "testset.instances.partial-update-title" "Partial Update")]

       [:div
        [:p (get-translation "test.versioning.bdd-tests-message.start"
                            "Update was done partially.")
         [:br]
         (get-translation "test.versioning.bdd-tests-message.middle"
                         "The selected Tests")
         ": "
         (interpose ", "
                    (for [test bdd-tests]
                      ^{:key (:id test)}
                      [:a {:href (:url test)
                           :target "_blank"}
                       (:display_id test)]))
         " "
         (get-translation "test.versioning.bdd-tests-message.end"
                         "are BDD type and can not be labeled.")]
        [:p (get-translation "testset.instances.skipped-tests-message.end" "They remain unchanged")]]

       [:div
        [buttons/button
         {:on-click #(re-frame/dispatch [::hide-bdd-message-modal])
          :primary? true
          :text (get-translation "generic.button.ok" "OK")}]]])))

(defn batch-version-label-modal []
  (fn []
    (let [show? @(re-frame/subscribe [::show-modal?])
          available-labels @(re-frame/subscribe [::available-labels])
          selected-labels @(re-frame/subscribe [::selected-labels])
          test-ids @(re-frame/subscribe [::test-ids])
          can-create-labels? @(re-frame/subscribe [::subs/versioning-can-create-labels?])]

      [label-common/version-label-modal
       {:title "test.batch-versioning.modal.title"
        :title-default "Set a Version Label"
        :description "test.batch-versioning.modal.description"
        :description-default "Add version labels for the test. Previously used labels are not displayed and cannot be reused."
        :hide-modal-event [::hide-label-modal]
        :apply-event [::apply-labels]
        :set-selection-event [::set-selected-labels]
        :create-label-event [::create-label]
        :show? show?
        :available-labels available-labels
        :selected-labels selected-labels
        :multi? true
        :placeholder (get-translation "test.versioning.unlabeled" "Unlabeled")
        :can-create-labels? can-create-labels?
        :button-text "generic.button.apply"
        :button-text-default "Apply"
        :button-disabled? empty?
        :apply-args [test-ids (vec selected-labels)]}])))
